import Backbone from 'backbone';
import Device from 'models/device/Device';

var Devices = Backbone.Collection.extend({
    model: Device,
    comparator: function(a, b) {
        return a
            .get('displayName')
            .toLowerCase()
            .localeCompare(b.get('displayName').toLowerCase());
    },

    url: function() {
        return '/device-service/deviceservice/device-info/all/' + this.getDisplayName();
    },

    backend: 'gcapi',

    initialize: function(args) {
        args = args || {};
        this.displayName = args.displayName;
    },

    /**
     * Setter for the DisplayName of the account these devices belong
     *
     * @param displayName
     */
    setDisplayName: function(displayName) {
        this.displayName = displayName;
    },

    /**
     * Getter for the DisplayName of the account these devices belong
     */
    getDisplayName: function() {
        return this.displayName;
    },

    // Determine if the user only has an Index scale(s) registered to their account
    userOnlyHasWeightScale: function() {
        if (this.length > 0) {
            for (var i = 0, length = this.length; i < length; i += 1) {
                if (this.models[i].get('applicationKey') !== 'indexSmartScale') {
                    return false;
                }
            }

            return true;
        }

        return false;
    },

    getActivityTrackers: function() {
        return this.models.filter(function(model) {
            if (model.get('wellness') || model.get('hybrid')) {
                // only return the device if it is able to be the users tracker
                return !model.isInUseByAnotherUser();
            }

            return false;
        });
    }

    //TODO: getSolarIntensityDevices()
});

export default Devices;
